import { Routes } from '@angular/router';
import { ViewInstitutionComponent } from './institution-management/view-institution/view-institution.component';
import { LdapListComponent } from './configuration/ldap-management/ldap-list/ldap-list.component';
import { RolesListComponent } from './users-management/roles-list/roles-list.component';
import { groupManagementRoutes } from './institution-management/group-management/group-management-routing.module';
import { InstitutionReportComponent } from '../../report-documents/institution-report/institution-report.component';

export const adminAccountRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./admin-dashboard/admin-dashboard.component').then(
        (m) => m.AdminDashboardComponent,
      ),
  },
  {
    path: 'meeting-portal',
    loadComponent: () =>
      import('../../meetings-management/meetings-portal/meetings-portal.component').then(
        (m) => m.MeetingsPortalComponent,
      ),
  },

  {
    path: 'users',
    loadComponent: () =>
      import('./users-management/users/users.component').then(
        (m) => m.UsersComponent,
      ),
  },
  {
    path: 'roles',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./users-management/roles-list/roles-list.component').then(
            (m) => m.RolesListComponent,
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./users-management/roles-list/view-role/view-role.component').then(
            (m) => m.ViewRoleComponent,
          ),
      },
    ],
  },

  {
    path: 'plans',
    loadComponent: () =>
      import('./plan-management/list-plans/list-plans.component').then(
        (m) => m.ListPlansComponent,
      ),
  },

  {
    path: 'plan-package/:id',
    loadComponent: () =>
      import('./plan-management/plan-package/plan-package.component').then(
        (m) => m.PlanPackageComponent,
      ),
  },

  {
    path: 'institutions',
    loadComponent: () =>
      import('./institution-management/institutions-list/institutions.component').then(
        (m) => m.InstitutionsComponent,
      ),
  },

  {
    path: 'institution/:id',
    loadComponent: () =>
      import('./institution-management/view-institution/view-institution.component').then(
        (m) => m.ViewInstitutionComponent,
      ),
  },
  {
    path: 'meetings-portal',
    loadComponent: ()=>
      import('../../report-documents/report-documents.component').then((m)=>m.ReportDocumentsComponent)
  },

  {
    path: 'feedback',
    loadComponent: () =>
      import('../../feedback/feedback.component').then(
        (m) => m.FeedbackComponent
      ),
  },
  {
    path: 'reports',
    children: [
      {
        path: '',
        loadComponent: () =>
        import('../../report-documents/reports/reports.component').then(
        (m) => m.ReportsComponent
      ),
      },
      {
        path: 'history-reports',
        loadComponent: ()=>
        import('../../report-documents/history-report/history-report.component').then((m)=>m.HistoryReportComponent)
      },
      {
        path: 'meeting-reports',
        loadComponent: ()=>
          import('../../report-documents/meeting-reports/meeting-reports.component').then((m)=>m.MeetingReportsComponent)
      },
      {
        path: 'meeting-summary',
        loadComponent: ()=>
          import('../../report-documents/meeting-summary/meeting-summary.component').then((m)=>m.MeetingSummaryComponent)
      },
      {
        path: 'instance-utilization',
        loadComponent: ()=>
          import('../../report-documents/instance-utilization/instance-utilization.component').then((m)=>m.InstanceUtilizationComponent)
      },
      {
          path: 'institution-reports',
          loadComponent: ()=>
            import('../../report-documents/institution-report/institution-report.component').then((m)=>m.InstitutionReportComponent)
      },
      {
        path: 'subscription-reports',
        loadComponent: ()=>
          import('../../report-documents/subscription-report/subscription-report.component').then((m)=>m.SubscriptionReportComponent)
      },
      {
        path: 'user-activity-reports',
        loadComponent: ()=>
          import('../../report-documents/user-activity-report/user-activity-report.component').then((m)=>m.UserActivityReportComponent)
      },
      {
        path: 'collision-summary-report',
        loadComponent: ()=>
          import('../../report-documents/collision-summary/collision-summary.component').then((m)=>m.CollisionSummaryComponent)
      }
    ]
    
  },
  {
    path: 'instances',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./instance-management/instances/instances.component').then(
            (m) => m.InstancesComponent,
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./instance-management/add-instance/add-instance.component').then(
            (m) => m.AddInstanceComponent,
          ),
      },
      {
        path: 'edit/:uniqueId',
        loadComponent: () =>
          import('./instance-management/add-instance/add-instance.component').then(
            (m) => m.AddInstanceComponent,
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./instance-management/view-instance/view-instance.component').then(
            (m) => m.ViewInstanceComponent,
          ),
      },
    ],
  },

  {
    path: 'ldaps',
    loadComponent: () =>
      import('./configuration/ldap-management/ldap-list/ldap-list.component').then(
        (m) => LdapListComponent,
      ),
  },

  {
    path: 'ldap/:id',
    loadComponent: () =>
      import('./configuration/ldap-management/view-ldap/view-ldap.component').then(
        (m) => m.ViewLdapComponent,
      ),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('./faq-management/faq-management.component').then(
        (m) => m.FaqManagementComponent,
      ),
  },
  {
    path: 'user-manual-management',
    loadComponent: () =>
      import('./user-manual-management/user-manual-management.component').then(
        (m) => m.UserManualManagementComponent,
      ),
  },
  {
    path: 'group/:id',
    loadComponent: () =>
      import('./institution-management/group-management/view-group/view-group.component').then(
        (m) => m.ViewGroupComponent,
      ),
    children: [...groupManagementRoutes],
  },
];
